import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;
  gap: 32px;
`;
